// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrors = {
  apiCodeUnknown: "请求失败，错误码：{code}",
} as const;
